import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { visitsAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { Mail, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';

export function SendVisitEmailModal({ open, onClose, mandateId, propertyAddress }) {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [sending, setSending] = useState(false);

    if (!open) return null;

    const send = async () => {
        if (!email.trim()) return;
        setSending(true);
        try {
            await visitsAPI.sendFormEmail({
                mandate_id: mandateId,
                visitor_email: email.trim(),
                visitor_name: name.trim() || null,
                property_address: propertyAddress,
                frontend_origin: window.location.origin,
            });
            toast.success(`Lien du questionnaire envoyé à ${email.trim()}`);
            setEmail('');
            setName('');
            onClose();
        } catch (e) {
            toast.error("Échec de l'envoi de l'email");
        } finally {
            setSending(false);
        }
    };

    return createPortal(
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="send-visit-email-modal">
            <div className="w-full max-w-md rounded-2xl bg-[#15101d] border border-white/10 shadow-2xl">
                <div className="flex items-center justify-between p-5 border-b border-white/10">
                    <div className="flex items-center gap-2">
                        <Mail className="w-5 h-5 text-[#FF914D]" />
                        <h3 className="font-bold text-white">Envoyer par email</h3>
                    </div>
                    <button onClick={onClose} className="text-white/40 hover:text-white" data-testid="send-email-close"><X className="w-5 h-5" /></button>
                </div>
                <div className="p-5 space-y-4">
                    <p className="text-sm text-muted-foreground">Le visiteur recevra le lien du questionnaire de visite par email.</p>
                    <div>
                        <label className="text-[10px] uppercase tracking-wider text-muted-foreground font-bold mb-1 block">Email du visiteur *</label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                            placeholder="visiteur@email.com"
                            className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm focus:outline-none focus:border-[#FF914D]/50"
                            data-testid="send-email-input" />
                    </div>
                    <div>
                        <label className="text-[10px] uppercase tracking-wider text-muted-foreground font-bold mb-1 block">Prénom (facultatif)</label>
                        <input value={name} onChange={e => setName(e.target.value)}
                            placeholder="Jean"
                            className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm focus:outline-none focus:border-[#FF914D]/50"
                            data-testid="send-email-name" />
                    </div>
                </div>
                <div className="flex justify-end gap-2 p-5 border-t border-white/10">
                    <Button variant="ghost" onClick={onClose} disabled={sending}>Annuler</Button>
                    <Button onClick={send} disabled={sending || !email.trim()}
                        className="bg-gradient-to-r from-[#681793] to-[#FF914D] text-white font-bold"
                        data-testid="send-email-submit">
                        {sending ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Mail className="w-4 h-4 mr-1.5" />}
                        Envoyer le lien
                    </Button>
                </div>
            </div>
        </div>,
        document.body
    );
}
